import {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {DeleteOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import {isFile} from 'helpers/utils';
import {OrderedFileDto} from '../../../../../PRMGApiClient';

interface ImageContainerProps {
  image: File | OrderedFileDto;
  onRemove: () => void;
}

export const ImageContainer: React.FC<ImageContainerProps> = memo(({image, onRemove}) => {
  const {t} = useTranslation();

  return (
    <div>
      <div className="bg-purple w-full h-48 rounded-lg flex justify-center content-center overflow-hidden h-48">
        <img
          src={isFile(image) ? URL.createObjectURL(image) : image.url ?? ''}
          alt="uploaded_image"
          className="w-full object-cover min-h-0 h-full;"
        />
      </div>
      <div className="flex justify-center gap-4 mt-2">
        <Button
          type="link"
          className="flex gap-2 justify-center"
          onClick={onRemove}
          icon={<DeleteOutlined className="text-lg" />}
        >
          {t('Remove')}
        </Button>
      </div>
    </div>
  );
});
